import { render, staticRenderFns } from "./overview-cell-contactdetails.vue?vue&type=template&id=639fed27&scoped=true"
import script from "./overview-cell-contactdetails.vue?vue&type=script&lang=ts"
export * from "./overview-cell-contactdetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639fed27",
  null
  
)

export default component.exports